<template>
  <div class="select-indicator">
    <div class="flex-column">
      <label for="indicator">{{ $t('indicador') }}</label>
      <b-form-select id="indicator" v-model="selectIndicator" :options="optionsIndicator" size="sm"
        class="mt-3"></b-form-select>
    </div>
    <div class="flex-column">
      <label for="process">{{ $t('processo') }}</label>
      <b-form-select id="process" v-model="selectProcess" :options="optionsProcess" size="sm"
        class="mt-3"></b-form-select>
    </div>
    <div class="flex-column">
      <label for="product">{{ $t('produto') }}</label>
      <b-form-select id="product" v-model="selectProduct" :disabled="disabledNotKey" :options="optionsProduct" size="sm"
        class="mt-3"></b-form-select>
    </div>
    <div class="flex-column">
      <label for="equipment">{{ $t('equipamento') }}</label>
      <b-form-select id="equipment" v-model="selectEquipment" :disabled="disabledNotKey" :options="optionsEquipment"
        size="sm" class="mt-3"></b-form-select>
    </div>
  </div>
</template>

<script>
import { defaultSuccess } from '../../../global';
import MediatorTrigger from '../tools/MediatorTrigger';

export default {
  name: "SelectIndicator",
  props: ["configuration", "reset"],
  data() {
    return {
      optionsIndicator: [{ value: null, disabled: true, text: this.$t('selecione-um-indicador-0') }],
      optionsProcess: [{ value: null, disabled: true, text: this.$t('selecione-um-processo') }],
      optionsProduct: [{ value: null, disabled: true, text: this.$t('selecione-um-produto') }],
      optionsEquipment: [{ value: null, disabled: true, text: this.$t('selecione-um-equipamento') }],
      filteredEquipments: [],
      disabledNotKey: true,
      selectIndicator: null,
      selectProcess: null,
      selectProduct: null,
      selectEquipment: null,
      selectProductId: null,
      selectEquipmentId: null,
      updatingTrigger: false,
      indicatorNameSelected: "",
      change: 0,
    }
  },
  watch: {
    reset() {
      this.selectIndicator = null;
      this.selectProcess = null;
      this.selectProduct = null;
      this.selectEquipment = null;
      this.disabledNotKey = true;
    },

    configuration(value) {
      this.setOptions(value)
    },

    selectIndicator(value) {
      if (!this.setIndicatorInTriggers(value)) return
      this.clearAllFields()
      this.selectProcess = null;
      this.selectProductId = null;
      this.selectEquipmentId = null;
    },

    selectProcess(value) {
      if (!this.setIndicatorInTriggers() && value == null) return
      setTimeout(() => {
        this.$emit("selectProcess", value);
        this.clearAllFields()
        if (this.selectIndicator) this.disabledNotKey = false
        this.selectProductId = null;
        this.selectEquipmentId = null;
        this.filterEquipmentsByProcess(value ? value.id : null);
        this.checkNeedToUpdateTrigger()
      }, 100)
    },

    selectProduct(value) {
      if (!this.setIndicatorInTriggers() && value == null) return
      this.clearInputFields()
      setTimeout(() => {
        this.$emit("selectProcess", this.selectProcess);
        this.$emit("selectProduct", value);
        this.selectProductId = value ? value.id : 0
        this.checkNeedToUpdateTrigger()
      }, 100);
    },

    selectEquipment(value) {
      if (!this.setIndicatorInTriggers() && value == null) return
      this.clearInputFields()
      setTimeout(() => {
        this.$emit("selectProcess", this.selectProcess);
        this.$emit("selectProduct", this.selectProduct);
        this.$emit("selectEquipment", value);
        this.selectEquipmentId = value ? value.id : 0
        this.checkNeedToUpdateTrigger()
      }, 100);
    },
  },

  methods: {
    loadForm(value) {
      this.updatingTrigger = true
      let keys = value.split('-');
      let indicator = this.optionsIndicator.find(i => i.value && i.value == `${keys[0]}-${keys[1]}-${keys[2]}`)
      this.disabledNotKey = false;

      if (indicator) {
        this.selectIndicator = indicator.value
        this.indicatorNameSelected = indicator.text
        setTimeout(() => this.$emit("loadConfiguration", indicator.value), 100)
        defaultSuccess(this.$t('carregando-gatilhos-do-indicador') + `${indicator.text}`)
      }

      let process = this.optionsProcess.find(p => p.value && p.value.id == keys[3])
      if (process)
        this.selectProcess = process.value

      setTimeout(() => {
        let product = this.optionsProduct.find(p => p.value && p.value.id == keys[4])
        if (product)
          this.selectProduct = product.value
        else
          this.selectProduct = null

        let equipment = this.optionsEquipment.find(p => p.value && p.value.id == keys[5])
        if (equipment)
          this.selectEquipment = equipment.value
        else
          this.selectEquipment = null
      }, 200)

      setTimeout(() => { this.updatingTrigger = false }, 1000)
    },

    setIndicatorInTriggers() {
      if (this.selectIndicator == null || this.updatingTrigger) return false
      this.$emit("selectIndicator", this.selectIndicator);
      this.$emit("loadConfiguration", this.selectIndicator)
      return true
    },

    setOptions(configuration) {
      this.setOptionsIndicator(configuration.dicIndicator)
      this.optionsIndicator = this.sortOption(this.optionsIndicator)
      this.optionsIndicator = this.optionsIndicator.filter(item => item.text != this.$t('selecione-um-indicador-0'))
      this.optionsIndicator.unshift({ value: null, disabled: true, text: this.$t('selecione-um-indicador-0') })
      

      this.optionsProcess = this.setOptionsArray(this.optionsProcess, configuration.process)
      this.optionsProcess = this.sortOption(this.optionsProcess)
      this.optionsProcess.unshift({ value: null, disabled: true, text: this.$t('selecione-um-processo') })

      this.optionsProduct = this.setOptionsArray(this.optionsProduct, configuration.product)
      this.optionsProduct = this.sortOption(this.optionsProduct)
      this.optionsProduct.unshift({ value: null, text: this.$t('selecione-um-produto') })

      this.optionsEquipment = this.setOptionsArray(this.optionsEquipment, configuration.equipment)
      this.optionsEquipment = this.sortOption(this.optionsEquipment)
      this.optionsEquipment.unshift({ value: null, text: this.$t('selecione-um-equipamento') })
    },

    setOptionsIndicator(indicators) {
      this.listKeys = Object.keys(indicators)
      this.listKeys = this.listKeys.sort((a, b) => a > b ? 1 : a < b ? -1 : 0);
      this.listKeys.forEach(key => {
        let text = indicators[key].indicatorName
        if (!this.optionsIndicator.find(o => o.text.toLocaleUpperCase() == text.toLocaleUpperCase()) && text != this.$t('selecione-um-indicador-0'))
          this.optionsIndicator.push({ value: key, text: text })
      })
    },

    setOptionsArray(newArray = new Array, array = new Array) {
      newArray = new Array()
      array.forEach(value => {
        let text = value.description
        if (!newArray.find(o => o.text.toLocaleUpperCase() == text.toLocaleUpperCase()))
          newArray.push({ value: { ...value }, text: text })
      })
      return newArray
    },

    sortOption(array = new Array()) {
      return array.sort((a, b) => a.text > b.text ? 1 : a.text == b.text ? 0 : -1)
    },

    checkNeedToUpdateTrigger() {
      if ((!this.selectIndicator && !this.selectProcess) || this.updatingTrigger) return
      MediatorTrigger.notify({
        indicatorKey: this.selectIndicator,
        processId: this.selectProcess ? this.selectProcess.id : 0,
        productId: this.selectProductId,
        equipmentId: this.selectEquipmentId
      }, "checkLoadTriger")
    },

    clearAllFields() {
      this.clearInputFields();
      this.selectProduct = null
      this.selectEquipment = null
    },

    clearInputFields() {
      this.$emit("resetFormTriggers", ++this.change);
      this.$emit("loadConfiguration", null)
    },

    messageDataLoaded() {
      defaultSuccess(this.$t('gatilho') + ` ${this.indicatorNameSelected} ` + this.$t('carregado-com-sucesso'))
    },

    filterEquipmentsByProcess(processId) {
      if (!processId) {
        this.filteredEquipments = [];
        this.optionsEquipment = [{ value: null, disabled: true, text: this.$t('selecione-um-equipamento') }];
        return;
      }
      
      this.filteredEquipments = this.configuration.equipment.filter(equipment => 
        equipment.processId === processId
      );

      this.optionsEquipment = [
        { value: null, disabled: true, text: this.$t('selecione-um-equipamento') },
        ...this.filteredEquipments.map(equipment => ({
          value: equipment,
          text: equipment.description
        }))
      ];
    },
  },

  mounted() {
    MediatorTrigger.notify(this, "initSelectIndicator")
  },
}
</script>

<style scoped src="../style.css"></style>
<style>
.select-indicator{
  display: flex;
    flex-direction: column;
    align-items: flex-start !important;
}

.select-indicator .flex-column{
  width: 100% !important;
}
</style>